import React from 'react';
import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

const list = [
    {
        title: '01. Сложный технологический стек',
        subtitle: '',
        // subtitle: 'Перед нами стоял вызов построить отказоустойчивую, масштабируемую, распределенную, гибкую архитектуру, учесть весь опыт создания собственных и заказных продуктов и реализовать его в этом проекте. Для этого нам пришлось изучить и внедрить много новых для нас технологий: Node.js + NestJS + TypeScript для backend, NestJS + SSR + React для frontend, RabbitMQ, Redis, MySQL, Elastic-стек для логирования, Kubernetes для управления кластеров физических и виртуальных серверов + minikube для локальной разработки, Prometheus + Grafana для логирования, и еще ряд других технологических решений.'
    },
    {
        title: '02. Автоматическое тестирование',
        subtitle: '',
        // subtitle: 'Для ускорения тестирования гипотез, уверенности в стабильности релизов мы покрыли основную бизнес логику проекта E2E-тестами, а также Unit и интеграционными тестами. Для тестов поднимается отдельная площадка во время релиза, где они прогоняются перед тем, как попасть на stage.'
    },
    {
        title: '03. Высокая нагрузка',
        subtitle:
            'Топовые сайты в этой категории имеют 35 000 000 посещений в месяц. Создание такого сервиса — достаточно сложное технологическое решение, где нужно сразу закладывать архитектурные решения. Нам понадобились десятки серверов — для frontend одни, для backend другие, для принятия файлов — третьи. А еще нельзя обойтись без сервера приложения, которое производит преобразование в файлах.',
    },
    {
        title: '04. Суперконкурентная тематика в SEO',
        subtitle:
            'Например, фразу «word to pdf» пользователи вводят в поисковую строку более 400 000 раз в месяц. По этой фразе выдается несколько тысяч специально оптимизированных страниц, но практически весь трафик получают только первые 10. Наша задача — попасть в эту десятку по сотням высокочастотных и супер конкурентным запросам.',
    },
    {
        title: '05. Сложности с локальной разработкой',
        subtitle:
            'С внедрением Kubernetes мы начали ставить Minikube на машины разработчикам и поняли, что упираемся в память рабочих машин. Тогда нам пришлось докупить более 16 гигов на каждую рабочую машину. Поднимать тестовые стеки в облаке было более дорогим решением, а решение через альтернативную конфигурацию с помощью docker-compose давал нам проблемы разности окружений. Но мы хотели максимально близкую к рабочей площадке копию и в итоге перешли на более легковесный аналог Minikube на локальных машинах и реализовали механизм создания отдельных площадок под каждую фичу в облаке на прерываемых машинах.',
    },
];

const list2 = [
    {
        title: 'Сложный технологический стек',
        subtitle: '',
        // subtitle: 'Тут будет текст о&nbsp;том, что у&nbsp;нас сложный технологический стек, как и&nbsp;в&nbsp;онлайн-конвертере. Мы&nbsp;набили руку на&nbsp;своих проектах и&nbsp;выучили новые технологии. А&nbsp;с&nbsp;конвертера еще добавились, а&nbsp;может и&nbsp;были частично: Node.js, NestJS, RabbitMQ, SSR, React, SPA, Microservice, CodeceptJS, Kubernetes, Helm.'
    },
    {
        title: ' Автоматическое тестирование',
        subtitle: '',
        // subtitle: 'Давно выяснено, что при оценке дизайна и&nbsp;композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а&nbsp;также реальное распределение букв и&nbsp;пробелов в&nbsp;абзацах, которое не&nbsp;получается при простой дубликации &laquo;Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст..&raquo;'
    },
    {
        title: 'Высокая нагрузка',
        subtitle:
            'Топовые сайты в&nbsp;этой категории имеют 35&nbsp;000&nbsp;000 посещений в&nbsp;месяц. Создание такого сервиса&nbsp;&mdash; достаточно сложное технологическое решение, где нужно сразу закладывать архитектурные решения. Нам понадобились десятки серверов&nbsp;&mdash; для фронтенда одни, для бэкенда другие, для принятия файлов&nbsp;&mdash; третьи. А&nbsp;еще нельзя обойтись без сервера приложения, которое производит преобразование в&nbsp;файлах.',
    },
    {
        title: 'Суперконкурентная тематика в SEO',
        subtitle:
            'Например, фразу &laquo;word to&nbsp;pdf&raquo; пользователи вводят в&nbsp;поисковую строку более 400&nbsp;000 раз в&nbsp;месяц. По&nbsp;этой фразе выдается несколько тысяч специально оптимизированных страниц, но&nbsp;практически весь трафик получают только первые 10. Наша задача&nbsp;&mdash; попасть в&nbsp;эту десятку по&nbsp;сотням высокочастотных и&nbsp;супер конкурентным запросам.',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="topdf-complex" bigPaddings={true} isMargin={false}>
                <div className="topdf-complex__wrapper">
                    <div className="topdf-complex__text">
                        <CommonTitle>Сложности</CommonTitle>
                        <CommonUsualText className="topdf-complex__subtitle" />
                    </div>

                    <div className="topdf-complex__info-list">
                        {list.map(({ title, subtitle }, index) => (
                            <ScrollAnimation
                                delay={100}
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className="topdf-complex__info-item"
                                key={index}
                            >
                                <CommonSmallTitle className="topdf-complex__info-title">
                                    {parse(title)}
                                </CommonSmallTitle>
                                <CommonSmallText className="topdf-complex__info-subtitle">
                                    {parse(subtitle)}
                                </CommonSmallText>
                            </ScrollAnimation>
                        ))}
                    </div>

                    <div className="topdf-process__collapse-list topdf-complex__mobile-list">
                        {list2.map(({ title, subtitle }, index) => (
                            <CommonCollapseItem
                                key={index}
                                gray={true}
                                index={++index}
                                triggerText={parse(title)}
                                content={parse(subtitle)}
                                classParent={'topdf-process__collapse-item '}
                                numberColor={'#c1272d'}
                            />
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
